export default "__VITE_ASSET__DLC4spU7__"